<template>
<div class="modal fade" id="modalOnboarding" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Onboarding.</h4>
      </div>

      <div class="modal-body">
        <div class="group-select">
          <label>Com quem foi o onboarding?</label>
          <select v-model="dataSendModal.onboardingWithWho" id="onboardingWithWho" name="onboardingWithWho" required>
            <option value="">Selecione</option>
            <option value="Rosa">Rosa</option>
            <option value="Karla">Karla</option>
            <option value="Kevin">Kevin</option>
            <option value="Andre">Andre</option>
            <option value="Mauricio">Mauricio</option>
            <option value="Claudia">Claudia</option>
            <option value="Nicole">Nicole</option>
            <option value="Marco">Marco</option>
            <option value="Alexandre">Alexandre</option>
            <option value="Rodrigo">Rodrigo</option>
          </select>
        </div>

        <div class="group-select-type">
          <label>Nota para o gestor de 1-5?</label>

          <div class="content-options1">
            <div v-on:click="dataSendModal.adminRating = 1" v-bind:class="{'active': dataSendModal.adminRating === 1}">1</div>
            <div v-on:click="dataSendModal.adminRating = 2" v-bind:class="{'active': dataSendModal.adminRating === 2}">2</div>
            <div v-on:click="dataSendModal.adminRating = 3" v-bind:class="{'active': dataSendModal.adminRating === 3}">3</div>
            <div v-on:click="dataSendModal.adminRating = 4" v-bind:class="{'active': dataSendModal.adminRating === 4}">4</div>
            <div v-on:click="dataSendModal.adminRating = 5" v-bind:class="{'active': dataSendModal.adminRating === 5}">5</div>
          </div>
        </div>

        <div class="group-select-type">
          <label>Pq escolheu a MarQPonto?</label>

          <div class="content-options2">
            <div v-on:click="listChoose.atendimento = !listChoose.atendimento" v-bind:class="{'active': listChoose.atendimento}">Atendimento</div>
            <div v-on:click="listChoose.vendas = !listChoose.vendas" v-bind:class="{'active': listChoose.vendas}">Vendas</div>
            <div v-on:click="listChoose.usabilidade = !listChoose.usabilidade" v-bind:class="{'active': listChoose.usabilidade}">Usabilidade</div>
            <div v-on:click="listChoose.preco = !listChoose.preco" v-bind:class="{'active': listChoose.preco}">Preço</div>
            <div v-on:click="listChoose.indicacao = !listChoose.indicacao" v-bind:class="{'active': listChoose.indicacao}">Indicação</div>
          </div>
        </div>

        <div class="group-select-type">
          <label>Quais ferramantas testou?</label>

          <div class="content-options3">
            <div v-on:click="listTools.tangerino = !listTools.tangerino" v-bind:class="{'active': listTools.tangerino}">Tangerino</div>
            <div v-on:click="listTools.pontoMais = !listTools.pontoMais" v-bind:class="{'active': listTools.pontoMais}">Ponto Mais</div>
            <div v-on:click="listTools.pontoTel = !listTools.pontoTel" v-bind:class="{'active': listTools.pontoTel}">Ponto Tel</div>
            <div v-on:click="listTools.oiTchau = !listTools.oiTchau" v-bind:class="{'active': listTools.oiTchau}">Oi Tchau</div>
            <div v-on:click="listTools.tecnoPonto = !listTools.tecnoPonto" v-bind:class="{'active': listTools.tecnoPonto}">TecnoPonto</div>
            <div v-on:click="listTools.qrPoint = !listTools.qrPoint" v-bind:class="{'active': listTools.qrPoint}">QrPoint</div>
            <div v-on:click="listTools.nada = !listTools.nada" v-bind:class="{'active': listTools.nada}">Nenhuma</div>
          </div>
        </div>

        <div class="group-select-type">
          <label>O que usavam antes antes?</label>

          <div class="content-options3">
            <div v-on:click="listBefore.manual = !listBefore.manual" v-bind:class="{'active': listBefore.manual}">Manual</div>
            <div v-on:click="listBefore.rep = !listBefore.rep" v-bind:class="{'active': listBefore.rep}">REP</div>
            <div v-on:click="listBefore.nada = !listBefore.nada" v-bind:class="{'active': listBefore.nada}">Nada</div>
          </div>
        </div>

        <div class="group-textarea">
          <label>Anotações<span>{{infoTag}}</span></label>
          <textarea v-model="dataSendModal.text" class="form-control" name="txtInfo"> </textarea>
        </div>

        <div class="group-select offset-top-20">
          <label>Enviar email para:</label>
          <input type="text" v-model="dataSendModal.sendEmailTo" class="form-control" name="sendEmailTo">
        </div>
      </div>

      <div class="modal-footer">
        <p>{{errorMsg}}</p>
        <button v-on:click="sendOnboarding()" :disabled="loadingSendModal" v-bind:class="{'disable': loadingSendModal}" type="submit" class="btn btn-register">
          <span v-if="!loadingSendModal">Enviar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  CREATE_ONBOARDING,
  SEND_EMAIL_ONBOARDING
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import swal from "sweetalert";

export default {
  name: "modalOnboarding",
  props: ['getInfo'],
  watch: {
    getInfo: function (val) {
      this.companyInfo = val;
    }
  },
  data() {
    return {
      companyInfo: {},
      infoTag: "(para realizar quebra de linha digite a tag <br>)",
      loadingSendModal: false,
      errorMsg: '',
      listChoose: {
        atendimento: false,
        vendas: false,
        usabilidade: false,
        preco: false,
        indicacao: false
      },
      listTools: {
        tangerino: false,
        pontoMais: false,
        pontoTel: false,
        oiTchau: false,
        tecnoPonto: false,
        qrPoint: false,
        nada: false
      },
      listBefore: {
        manual: false,
        rep: false,
        nada: false
      },
      dataSendModal: {
        userId: JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id,
        pipelineId: this.$route.params.idPipe,
        pipelineBusinessId: this.$route.params.idBusiness,
        sendEmailTo: '',
        businessNoteType: 7,
        onboardingWithWho: '',
        adminRating: null,
        whyMarQPonto: '',
        companyTestedBefore: '',
        whatUsedBefore: '',
        text: ''
      }
    }
  },
  methods: {
    closeModal() {
      $('#modalOnboarding').modal('toggle');
    },
    sendEmail() {
      REQUEST_SERVICE.get(SEND_EMAIL_ONBOARDING + "?email=" + this.dataSendModal.sendEmailTo + "&companyId=" + this.companyInfo.companyId + "&contextCode=" + this.companyInfo.context).then((response) => {
        UTIL_SERVICE.console("RESULT SEND_EMAIL_ONBOARDING:", response.data);

        swal("Aviso", response.data, "success");

        this.loadingSendModal = false;
        $('#modalOnboarding').modal('toggle');
      }).catch((reason) => {
        this.loadingSendModal = false;
        $('#modalOnboarding').modal('toggle');

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

    },
    sendOnboarding() {
      this.errorMsg = '';
      this.dataSendModal.whatUsedBefore = '';
      this.dataSendModal.companyTestedBefore = '';
      this.dataSendModal.whyMarQPonto = '';

      if (this.listChoose.vendas) {
        this.dataSendModal.whyMarQPonto = 'Vendas';
      }
      if (this.listChoose.atendimento) {
        if (this.dataSendModal.whyMarQPonto.length > 1) this.dataSendModal.whyMarQPonto += ',';
        this.dataSendModal.whyMarQPonto += 'Atendimento';
      }
      if (this.listChoose.usabilidade) {
        if (this.dataSendModal.whyMarQPonto.length > 1) this.dataSendModal.whyMarQPonto += ',';
        this.dataSendModal.whyMarQPonto += 'Usabilidade';
      }
      if (this.listChoose.preco) {
        if (this.dataSendModal.whyMarQPonto.length > 1) this.dataSendModal.whyMarQPonto += ',';
        this.dataSendModal.whyMarQPonto += 'Preço';
      }

      if (this.listChoose.indicacao) {
        if (this.dataSendModal.whyMarQPonto.length > 1) this.dataSendModal.whyMarQPonto += ',';
        this.dataSendModal.whyMarQPonto += 'Indicação';
      }

      // Quais ferramantas testou?
      if (this.listTools.nada) {
        this.dataSendModal.companyTestedBefore = 'Nenhuma'
      }
      if (this.listTools.tangerino) {
        this.dataSendModal.companyTestedBefore = 'Tangerino';
      }
      if (this.listTools.pontoMais) {
        if (this.dataSendModal.companyTestedBefore.length > 1) this.dataSendModal.companyTestedBefore += ',';
        this.dataSendModal.companyTestedBefore += 'Ponto Mais';
      }
      if (this.listTools.pontoMais) {
        if (this.dataSendModal.companyTestedBefore.length > 1) this.dataSendModal.companyTestedBefore += ',';
        this.dataSendModal.companyTestedBefore += 'Ponto Mais';
      }
      if (this.listTools.pontoTel) {
        if (this.dataSendModal.companyTestedBefore.length > 1) this.dataSendModal.companyTestedBefore += ',';
        this.dataSendModal.companyTestedBefore += 'Ponto Tel';
      }
      if (this.listTools.oiTchau) {
        if (this.dataSendModal.companyTestedBefore.length > 1) this.dataSendModal.companyTestedBefore += ',';
        this.dataSendModal.companyTestedBefore += 'Oi Tchau';
      }
      if (this.listTools.tecnoPonto) {
        if (this.dataSendModal.companyTestedBefore.length > 1) this.dataSendModal.companyTestedBefore += ',';
        this.dataSendModal.companyTestedBefore += 'Tecno Ponto';
      }
      if (this.listTools.qrPoint) {
        if (this.dataSendModal.companyTestedBefore.length > 1) this.dataSendModal.companyTestedBefore += ',';
        this.dataSendModal.companyTestedBefore += 'Qr Point';
      }

      // O que usavam antes antes.
      if (this.listBefore.manual) {
        this.dataSendModal.whatUsedBefore += 'Manual';
      }
      if (this.listBefore.rep) {
        if (this.dataSendModal.whatUsedBefore.length > 1) this.dataSendModal.whatUsedBefore += ',';
        this.dataSendModal.whatUsedBefore += 'REP';
      }
      if (this.listBefore.nada) {
        if (this.dataSendModal.whatUsedBefore.length > 1) this.dataSendModal.whatUsedBefore += ',';
        this.dataSendModal.whatUsedBefore += 'Nada';
      }

      if (this.dataSendModal.onboardingWithWho && this.dataSendModal.adminRating && this.dataSendModal.whyMarQPonto && this.dataSendModal.companyTestedBefore && this.dataSendModal.whatUsedBefore) {
        if (!this.loadingSendModal) {
          this.loadingSendModal = true;
          UTIL_SERVICE.console("Data send: ", this.dataSendModal);
          REQUEST_SERVICE.post(CREATE_ONBOARDING, this.dataSendModal).then((response) => {
            UTIL_SERVICE.console("RESULT CREATE_ONBOARDING:", response.data);

            if (this.dataSendModal.sendEmailTo) {
              this.sendEmail();
            } else {
              swal("Aviso", response.data, "success");

              this.loadingSendModal = false;
              $('#modalOnboarding').modal('toggle');
            }
          }).catch((reason) => {
            this.loadingSendModal = false;
            $('#modalOnboarding').modal('toggle');

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
        }
      } else {
        this.errorMsg = 'Preencha/Selecione todos os campos.';
      }
      //
    }
  }
}
</script>

<style lang="scss">
#modalOnboarding {
  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  label {
    span {
      font-size: 12px;
      display: inline-block;
      margin-left: 5px;
    }
  }

  .double-btn-center {
    display: block;
    margin: 0 auto 50px;

    .first {
      background: #00a651;
      color: #fff;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #008d45;
      }
    }

    .second {
      background: #0F77AE;
      color: #fff;
      width: 49%;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #054F91;
      }
    }

    .third {
      background: #c29d0b;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #aa890a;
      }
    }

    .four {
      background: #e74a4e;
      color: #fff;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #e43338;
      }
    }
  }

  .form-group {
    display: inline-block;
    margin-bottom: 20px;

    input {
      height: 37px;
    }

    textarea {
      border-radius: 4px !important;
      height: 150px;
      margin-top: 10px;
    }
  }

  .send-btn-modal {
    background: #3598dc;
    color: #fff;
    border: none;
    padding: 0 15px;
    height: 37px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto 0 0;

    &:hover {
      background-color: #054F91;
    }
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;

    .group-select {
      display: block;

      label {
        display: block;
      }

      select {
        width: 100%;
        height: 36px;
      }
    }

    .group-select-type {
      display: block;
      margin-top: 20px;

      label {
        display: block;
        margin-bottom: 10px;
      }

      .content-options1 {
        div {
          display: inline-block;
          border: 1px solid rgba(85, 85, 85, 0.62);
          color: #555;
          padding-top: 15px;
          min-width: 70px;
          height: 50px;
          border-radius: 4px !important;
          cursor: pointer;
          text-align: center;
          margin-bottom: 15px;
          margin-right: 10px;
        }
      }

      .content-options2 {
        div {
          display: inline-block;
          border: 1px solid rgba(85, 85, 85, 0.62);
          color: #555;
          padding-top: 15px;
          min-width: 95px;
          height: 50px;
          border-radius: 4px !important;
          cursor: pointer;
          text-align: center;
          margin-bottom: 15px;
          margin-right: 10px;
        }
      }

      .content-options3 {
        div {
          display: inline-block;
          border: 1px solid rgba(85, 85, 85, 0.62);
          color: #555;
          padding-top: 15px;
          min-width: 100px;
          height: 50px;
          border-radius: 4px !important;
          cursor: pointer;
          text-align: center;
          margin-bottom: 15px;
          margin-right: 10px;
        }
      }

      .active {
        background: #3598dc;
        color: #fff !important;
        border: 1px solid #3598dc !important;
      }
    }

    .group-textarea {
      margin-top: 20px;

      label {
        display: block;
      }

      textarea {
        display: block;
        width: 100%;
        height: 90px;
      }
    }
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalOnboarding.vue